import type { Dictionnaire } from '../type';
import { compte as nombre } from './pluriel';

export const profil: Dictionnaire['profil'] = {
  erreurs: {
    compteIntrouvable: 'الحساب غير موجود',
    membreIntrouvable: 'العضو غير موجود',
    pseudoPris: 'اسم المستخدم هذا مأخوذ',
    spotIntrouvable: 'المدينة غير موجودة',
    bientot: (spot: string) => `${spot} ستُفتح قريبًا، ترقّبوا!`,
    prive: (spot: string) => `${spot} مخصّصة لأعضائها فقط.`,
  },
  aideErreurs: {
    vide: 'أخبرنا بما يحدث',
  },
  commun: {
    changerPhoto: 'تغيير صورة ملفي',
    mesDestinations: 'وجهاتي',
    mesPosts: 'منشوراتي',
    mesEvenements: 'فعالياتي',
    mesAmis: 'أصدقائي',
    mesSignets: 'محفوظاتي',
    voirTout: 'عرض الكل',
    notePar: (note: string, n: number) => `تقييم ${note} من 5 من ${nombre(n, 'مشارك واحد', 'مشاركَين', 'مشاركين', 'مشاركًا')}`,
    personnaliser: 'تخصيص ملفي',
    bio: 'نبذة',
    debloquer: 'إلغاء الحظر',
    membresBloques: 'الأعضاء المحظورون',
    visibilite: 'ظهور الملف',
    parametres: 'الإعدادات',
    aide: 'المساعدة والإبلاغ',
    ajouterAmis: 'إضافة أصدقاء',
    ecrireA: (nom: string) => `مراسلة ${nom}`,
  },
  compte: {
    photoMiseAJour: 'تم تحديث الصورة.',
    photoRetiree: 'أُزيلت الصورة.',
    photoImpossible: 'تعذّر حفظ الصورة',
    enregistre: 'تم حفظ الملف.',
    impossible: 'تعذّر الحفظ',
    enregistrer: 'حفظ',
    retirerPhoto: 'إزالة صورتي',
    pseudo: 'اسم المستخدم',
    bioExemple: 'سطران عنك وعمّا تبحث عنه هنا…',
    langues: 'اللغات التي تتحدثها',
    languesAide: 'تظهر الخرجات بلغاتك أولًا في القائمة.',
  },
  masques: {
    titre: 'المخفيون والمحظورون',
    comptesMasques: 'الحسابات المخفية',
    comptesBloques: 'الحسابات المحظورة',
    postsMasques: 'المنشورات المخفية',
    afficher: 'إلغاء الإخفاء',
    impossible: 'تعذّر ذلك الآن.',
    comptes: {
      personne: 'لا توجد حسابات مخفية',
      personneAide: 'يمكنك إخفاء حساب من ملفه، عبر النقاط الثلاث في الأعلى.',
      explication: 'لن ترى منشوراتهم ولا خرجاتهم بعد الآن. هم لا يعلمون بذلك، ولا يتغيّر شيء آخر بينكم.',
      masque: 'مخفي',
    },
    posts: {
      aucun: 'لا توجد منشورات مخفية',
      aucunAide: 'المنشورات التي تخفيها من الأخبار تجدها هنا.',
    },
  },
  bloques: {
    impossible: 'تعذّر إلغاء الحظر الآن.',
    personne: 'لا يوجد أحد محظور',
    personneAide: 'يمكنك حظر عضو من ملفه، عبر النقاط الثلاث في الأعلى.',
    explication: 'لن تظهر لك منشوراته وفعالياته بعد الآن، وتُخفى محادثاتكما.',
    bloque: 'محظور',
  },
  destinations: {
    villes: 'المدن',
    actuel: 'الخادم الحالي',
    changer: 'تغيير الخادم',
  },
  amis: {
    aucun: 'ليس لديك أصدقاء بعد',
    aucunAide: 'اقتراحات الخادم والطلبات الواردة بانتظارك.',
    trouver: 'البحث عن أعضاء',
  },
  aide: {
    impossible: 'تعذّر الإرسال الآن.',
    envoyer: 'إرسال',
    intro: 'أخبرنا بما يحدث. فريقنا يقرأ كل شيء ويردّ عبر البريد الإلكتروني.',
    sujet: 'بخصوص ماذا؟',
    raconte: 'احكِ لنا',
    raconteExemple: 'ما الذي حدث، وأين، ومع من إن لزم.',
    sujets: {
      member: 'عضو',
      event: 'فعالية',
      content: 'منشور أو رسالة',
      bug: 'مشكلة تقنية',
      other: 'أمر آخر',
    },
  },
  membre: {
    ami: {
      none: 'إضافة صديق',
      requested: 'تم إرسال الطلب',
      incoming: 'قبول الطلب',
      friends: 'إزالة من الأصدقاء',
    },
    ceMembre: 'هذا العضو',
    profil: 'الملف',
    refuserQ: 'رفض طلب صداقته؟',
    refuser: 'رفض طلب الصداقة',
    debloquerMembre: 'إلغاء حظر هذا العضو',
    bloquerMembre: 'حظر هذا العضو',
    masquerCompte: 'إخفاء هذا الحساب',
    nePlusMasquer: 'إلغاء إخفاء هذا الحساب',
    estMasque: (nom: string) => `تم إخفاء ${nom}. لن ترى بعد الآن منشورات هذا الشخص ولا فعالياته.`,
    plusMasque: (nom: string) => `أُلغي إخفاء ${nom}.`,
    ecrire: 'مراسلة',
    tuAsBloque: 'لقد حظرت هذا العضو',
    tuAsBloqueAide: 'لم تعد منشورات هذا الشخص تظهر في أخبارك، ولم يعد يُقترح عليك.',
    officiel: 'هذا حساب فريق Sirocco. راسله بأي سؤال.',
    reserve: 'الملف مرئي للأصدقاء فقط',
    reserveAide: 'أرسل طلب صداقة لترى منشوراته.',
    sesDestinations: 'وجهاته',
    sesEvenementsMasques: 'فعالياته مخفية بحسب إعداداته.',
    demandeRefusee: (nom: string) => `رُفض طلب ${nom}.`,
    debloque: (nom: string) => `أُلغي حظر ${nom}.`,
    bloquerQ: (nom: string) => `حظر ${nom}؟`,
    bloque: (nom: string) => `تم حظر ${nom}. لم يعد بإمكان هذا الشخص مراسلتك ولا إرسال طلب صداقة إليك.`,
    retirerAmiQ: (nom: string) => `إزالة ${nom} من أصدقائك؟`,
    plusAmi: (nom: string) => `لم يعد ${nom} صديقك.`,
    appeler: (nom: string) => `الاتصال بـ ${nom}`,
    avis: (n: string) => `· ${n} تقييم`,
  },
  notifications: {
    choix: {
      messages: 'الرسائل',
      appels: 'المكالمات',
      amis: 'طلبات الصداقة',
      postsAmis: 'منشورات أصدقائي',
      evenements: 'الفعاليات',
      acceptee: 'قبول المشاركة',
      inscriptions: 'التسجيل في فعالياتي',
      desinscriptions: 'الانسحاب من فعالياتي',
      reactions: 'التفاعل مع منشوراتي',
      mentions: 'الإشارات',
    },
    titre: 'الإشعارات',
  },
  motDePasse: {
    troisConditions: 'كلمة المرور هذه لا تستوفي الشروط الثلاثة',
    pasIdentiques: 'كلمتا المرور غير متطابقتين',
    impossible: 'تعذّر التغيير',
    titre: 'البريد الإلكتروني وكلمة المرور',
    changer: 'تغيير كلمة المرور',
    actuel: 'كلمة المرور الحالية',
    nouveau: 'كلمة المرور الجديدة',
    confirmer: 'تأكيد كلمة المرور الجديدة',
    envoye: 'تم إرسال الرسالة',
    lienRecu: (email: string) => `افتح الرابط المرسل إلى ${email} لاختيار كلمة مرور جديدة.`,
  },
  ecran: {
    modifier: 'تعديل ملفي',
    mesEvenementsSorties: 'فعالياتي وخرجاتي',
  },
  visibilite: {
    intro: 'اختر ما يراه أعضاء الخادم الآخرون عند فتح ملفك.',
    quiPeutVoir: 'من يمكنه رؤية ملفي',
    toutLeServeur: 'الخادم كله',
    amisSeulement: 'أصدقائي فقط',
    ceQuiApparait: 'ما يظهر في ملفي',
    evenementsAide: 'يرى الآخرون ما أشارك فيه',
    mesDestinationsAide: 'المدن التي مررت بها',
    postsAide: 'مرئية من ملفي',
    enLigne: 'حالة الاتصال',
    enLigneAide: 'نقطة خضراء على صورتي',
    destinationsAmis: 'وجهاتي للأصدقاء فقط',
    destinationsAide: 'المدن التي مررت بها، لأصدقائي فقط',
    messages: 'الرسائل',
  },
  tableau: {
    mois: 'آخر 30 يومًا',
    posts: 'منشورات',
    tenues: 'فعاليات أُقيمت',
    presences: 'حضور',
    inscriptions: 'التسجيلات أسبوعيًا',
    cetteSemaine: 'هذا الأسبوع',
    ilYaSemaines: (n: number) => `قبل ${n} أسابيع`,
    nInscriptions: (n: number) => `${n} تسجيلات`,
    fidelite: 'الولاء',
    revenus: 'يعودون بعد أسبوعهم الأول',
    encoreActifs: 'ما زالوا نشطين بعد شهر',
    surN: (n: number, sur: number) => `${n} من ${sur}`,
    pasAssez: 'لا توجد مدة كافية بعد',
    parServeur: 'حسب الخادم',
    serveurLigne: (membres: number, actifs: number) => `${membres} أعضاء · ${actifs} نشطون هذا الأسبوع`,
    serveurDetail: (posts: number, tenues: number, presences: number, aVenir: number) =>
      `${posts} منشورات (7 أيام) · ${tenues} فعاليات و${presences} حضور (30 يومًا) · ${aVenir} قادمة`,
    sansServeur: 'بلا خادم',
    titre: 'لوحة المتابعة',
    actifsAujourdhui: 'نشطون اليوم',
    semaine: 'هذا الأسبوع',
    comptes: 'حسابات',
    nouveaux: 'جدد (7 أيام)',
    unSignalement: 'بلاغ واحد بانتظار قرار',
    connexions: 'آخر عمليات الدخول',
    versions: 'الإصدارات المثبّتة',
    unCompte: 'حساب واحد',
    sorties: 'الخرجات القادمة',
    rien: 'لا شيء مخطّط بعد.',
    spontanee: 'عفوية',
    jamais: 'أبدًا',
    depuis: {
      minutes: (n: number) => `منذ ${n} د`,
      heures: (n: number) => `منذ ${n} س`,
      jours: (n: number) => `منذ ${n} ي`,
    },
    build: (n: string) => ` · بناء ${n}`,
    signalements: (n: number) => `${nombre(n, 'بلاغ واحد', 'بلاغان', 'بلاغات', 'بلاغًا')} بانتظار قرار`,
    nComptes: (n: number) => nombre(n, 'حساب واحد', 'حسابان', 'حسابات', 'حسابًا'),
  },
  reglages: {
    apparences: {
      system: 'تلقائي',
      day: 'فاتح',
      night: 'داكن',
    },
    apparenceAide: {
      system: 'يتبع إعداد هاتفك.',
      day: 'فاتح دائمًا، مهما كان إعداد الهاتف.',
      night: 'داكن دائمًا، مهما كانت الساعة.',
    },
    deconnexionImpossible: 'تعذّر تسجيل الخروج. أعد المحاولة.',
    suppressionImpossible: 'تعذّر الحذف',
    compte: 'الحساب',
    emailEtMotDePasse: 'البريد الإلكتروني وكلمة المرور',
    serveur: 'الخادم / الوجهة',
    confidentialite: 'الخصوصية',
    coupees: 'متوقفة في إعدادات الهاتف',
    moderation: 'الإشراف',
    tableau: 'لوحة المتابعة',
    administration: 'الإدارة',
    application: 'التطبيق',
    apparence: 'المظهر',
    langue: 'اللغة',
    deconnecterQ: 'تسجيل الخروج؟',
    deconnecter: 'تسجيل الخروج',
    supprimerQ: 'حذف حسابك نهائيًا؟ ستُمحى منشوراتك ورسائلك.',
    supprimer: 'حذف حسابي',
  },
};
